import { cloud, pine, rock } from '../motifs';
import { registerPlate } from '../registry';

const STONE = ['#d8c4a4', '#a88c68', '#6e5640'] as const;
const MIST = ['#fbf6ec', '#e2d8c8', '#b4a890'] as const;

/** 18 พเนจร: the wilds plate, earth brown lacquer with a pine on rocks and clouds on the far end. */
registerPlate({
  id: 'wilds',
  name: 'พเนจร',
  ground: ['#6e4c30', '#4a3220', '#2e1e14'],
  trim: '#c8a070',
  text: { fill: ['#fff4dc', '#f0d4a0'], line: '#160c06' },
  inset: [16, 14],
  front(p, f) {
    rock(p, f.x - 10, f.b + 5, 18, 16, STONE);
    rock(p, f.x + 5, f.b + 4, 11, 9, STONE);
    pine(p, f.x + 1, f.y + 6, f.x + 10, f.y - 12, [
      [f.x + 1, f.y - 4, 15],
      [f.x + 13, f.y - 10, 16],
      [f.x + 6, f.y - 16, 11],
    ]);
    rock(p, f.r - 8, f.b + 4, 16, 10, STONE);
    cloud(p, f.r - 17, f.y + 4, 24, MIST, true);
  },
  motion: {
    sprites: { wisp: { w: 12, h: 8, draw: (p) => cloud(p, 0, 8, 12, MIST) } },
    play(a, t, f) {
      a.spr('wisp', f.r - 24 + Math.sin(t * 0.5) * 4, f.y - 10);
      a.spr('wisp', f.x + 14 + Math.sin(t * 0.4 + 2) * 3, f.b - 1);
    },
  },
});
